const DealItemModel = Backbone.Model.extend({
  defaults: {
    sailing_id: 0,
    ship_id: 0,
    ship_name: "",
    duration: 0,
    destination: "",
    destination_id: 0,
    departure_port: "",
    departure_port_id: 0,
    departure_date: 0,
    vendor_id: 0,
    vendor_name: "",
    from_prices: {
      inside: 0,
      oceanview: 0,
      balcony: 0,
      suite: 0,
      currency: "",
      airport_code: "",
      lowest: 0
    }
  }
});

const HomeDealItemModel = Backbone.Model.extend({
  defaults: {
    id: 0,
    version_id: 0,
    title: "",
    description: "",
    booking_range: [
      {
        start: 0,
        end: 0
      }
    ],
    vendor_id: 0
  }
});

const DealItemsCollection = Backbone.Collection.extend({
  initialize: function(models, options) {
    this.model = options.isHome ? HomeDealItemModel : DealItemModel;
    this.url = options.url;
    this.fallbackUrl = options.fallbackUrl;
    this.wrapper = options.el;
  },

  parse: function(response) {
    return response.data;
  },

  fetchAllItems: function(options = {}) {
    return this.fetch({
      reset: true,
      ...options,
      success: (collection, response, opts) => {
        if (!response.success) {
          this.wrapper.addClass("is-hidden");

          if (this.fallbackUrl) {
            Backbone.Events.trigger("loadingSplashOn");
            window.location.href = this.fallbackUrl;
          }
          return;
        }

        if (typeof options.success === "function") {
          options.success(collection, response, opts);
        }
      },
      error: (collection, response, opts) => {
        if (typeof options.error === "function") {
          options.error(collection, response, opts);
        }
      }
    });
  }
});

var DealItemsView = Backbone.View.extend({
  currentPage: 0,
  loading: false,
  threshold: 100,

  events: {
    "click [data-deals-load-more]": "renderNextPage"
  },

  initialize: function() {
    if (this.$el.data("settings")) {
      this.settings = $.extend(
        true,
        this.settings,
        eval(this.$el.data("settings"))
      );
    }

    this.pageSize = this.settings.pageSize || 5;

    this.templateWrapper = this.$("[data-deals-item-wrapper]");

    this.template = Handlebars.compile(
      this.$("[data-deals-item-template]")?.length
        ? this.$("[data-deals-item-template]").html()
        : ""
    );

    let currentFetchUrl = this.settings.fetchItems;
    let currentFallbackUrl = this.settings.fallbackURL;
    this.workflow = this.settings.workflow || "CRUISE";

    if (this.settings.queryKey) {
      const params = new URLSearchParams(window.location.search).get(
        this.settings.queryKey
      );

      currentFetchUrl = `${this.settings.fetchItems}?${
        this.settings.queryKey
      }=${params}`;
    }

    this.collection = new DealItemsCollection([], {
      url: currentFetchUrl,
      fallbackUrl: currentFallbackUrl,
      el: this.$el
    });

    this.listenTo(this.collection, "reset", this.renderFirstPage);
    this.collection.fetchAllItems();

    $(window).on("scroll", _.throttle(this.checkScroll.bind(this), 200));
  },

  renderFirstPage: function() {
    this.currentPage = 0;

    this.templateWrapper.empty();
    this.renderNextPage();
  },

  renderNextPage: function() {
    if (this.loading) return;

    this.loading = true;

    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    const itemsToRender = this.collection.slice(start, end);

    _.each(itemsToRender, (model, index) => {
      let currentModel = model.toJSON();

      currentModel.workflow = this.workflow;

      if (this.settings.sanitizeText) {
        currentModel.title = $(currentModel.title).length
          ? this.sanitizeHtml(currentModel.title)
          : "";

        currentModel.description = $(currentModel.description).length
          ? this.sanitizeHtml(currentModel.description)
          : "";
      }

      currentModel.ship_image = currentModel.ship_image?.replace(
        ".jpg",
        "_lg.jpg"
      );

      // Inject the global iteration number
      currentModel.iteration = parseInt(
        (this.currentPage - 1) * this.pageSize + index
      );

      const html = this.template(currentModel);
      this.templateWrapper.append(html).loadComponents();
    });

    this.currentPage++;

    this.loading = false;

    if (this.currentPage * this.pageSize >= this.collection.length) {
      this.$("[data-deals-load-more]")
        .attr("disabled", "disabled")
        .addClass("is-disabled");
    }
  },

  checkScroll: function() {
    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();
    const docHeight = this.$el.parents("[data-main-area-container]").height();

    if (scrollTop + windowHeight + this.threshold >= docHeight) {
      if (this.currentPage * this.pageSize < this.collection.length) {
        this.renderNextPage();
      }
    }
  },

  remove: function() {
    $(window).off("scroll");
    Backbone.View.prototype.remove.call(this);
  },

  sanitizeHtml: function(string) {
    return $("<div>")
      .html(string)
      .find("[style]")
      .removeAttr("style")
      .end()
      .html();
  }
});

module.exports = DealItemsView;
